(function ($, Drupal) {
  Drupal.behaviors.carouselImages = {
    attach(context) {
      $('.view-carousel .view-content').slick({
        infinite: true,
        speed: 300,
        fade: true,
        cssEase: 'linear',
        slidesToShow: 1,
        centerPadding: 0,
        adaptiveHeight: true,
        dots: false,
        slidesToScroll: 1,
        autoplay: true,
        arrows: false,
        autoplaySpeed: 3500,
      });
      $('.view-carousel .view-content').slick('refresh');
    },
  };

  Drupal.behaviors.carouselPageImages = {
    attach(context) {
      $('.paragraph--type--carousel .field--name-field-images').slick({
        infinite: true,
        speed: 300,
        fade: true,
        cssEase: 'linear',
        slidesToShow: 1,
        centerPadding: 0,
        adaptiveHeight: true,
        dots: false,
        slidesToScroll: 1,
        autoplay: true,
        arrows: false,
        autoplaySpeed: 3500,
      });
      $('.paragraph--type--carousel .field--name-field-images').slick(
        'refresh',
      );
      $('.paragraph--type--carousel').insertBefore('main');
      $('.node--type-article .field--name-field-header-image').insertBefore(
        'main',
      );
    },
  };
})(jQuery, Drupal);
